<template>
    <b-card no-body style="border: none; height: 100%; margin: 0;">
        <b-table no-provider-paging striped bordered hover responsive id="my-table" :items="tableData"
                 :per-page="perPage"
                 :current-page="currentPage"
                 tbody-tr-class="test"
                 :fields="fields" v-on:row-clicked="rowClicked"
        class="custom-auto-height">
            <template v-slot:cell(offen)="row">
                    <book-open-page-variant-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red" v-if="row.item.offen === 0 && row.item.art === 'AU'"></book-open-page-variant-icon>
                    <check-bold-icon class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: green" v-if="row.item.offen === 1 && row.item.art === 'AU'"></check-bold-icon>
                    <currency-eur-icon class="icon-1_5x" fillColor="#484848" style="color: black" :size="72" v-if="row.item.offen === 3 && row.item.art === 'AU'"></currency-eur-icon>
                    <close-circle-icon class="icon-1_5x" fillColor="#ac121b" style="color: red" :size="72" v-if="row.item.art === 'DE' || row.item.art === 'DC'"></close-circle-icon>
                    </template>
            <template v-slot:cell(details)="row">
                <b-button variant="primary" size="sm" v-if="!row.detailsShowing" @click="row.toggleDetails">
                    <i class="fa fa-chevron-down"></i>
                </b-button>
                <b-button variant="primary" size="sm" v-if="row.detailsShowing" @click="row.toggleDetails">
                    <i class="fa fa-chevron-up"></i>
                </b-button>
            </template>

            <template #row-details="row">
                <b-row>
                    <b-col sm="9">
                        <b-card class="mb-0">
                            <template #header>
                                <strong>Details</strong>
                            </template>
                            <b-row>
                                <b-col sm="5"><b>Rechnung: </b>
                                    <a
                                            v-for="item in (row.item.rechnungen === null ? '' : row.item.rechnungen).split(';')"
                                            v-if="item !== ''"
                                            target="_blank"
                                            v-on:click.prevent="showFile(url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=R', item)"
                                            :href="url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=R'">
                                        {{item}};
                                    </a></b-col>
                                <b-col><b>Konto: </b>{{ row.item.gi_hh_aus }}</b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="5"><b>Voranschlag: </b>{{ formateMoney(row.item.kosten_voranschlag) }}</b-col>
                                <b-col ><b>RNr: </b>{{ row.item.rnr }}</b-col>
                            </b-row>
                            <b-row ><b-col sm="5"><b>Gesamtpreis: </b>{{ formateMoney(row.item.kosten) }}</b-col>
                                <b-col ><b>Anhänge: </b>
                                <a
                                    v-for="item in (row.item.anlagen === null ? '' : row.item.anlagen).split(';')"
                                    v-if="item !== ''"
                                    target="_blank"
                                    v-on:click.prevent="showFile(url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A', item)"
                                    :href="url + '/auftragsbuch/upload/file/'+row.item.id+'?file_name='+encodeURIComponent(item)+'&file_type=A'">
                                    {{item}};
                                </a></b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col>
                                <b-button variant="primary" class="btn-pill" v-on:click="rowClicked(row.item)">
                                    &nbsp;Zum Auftrag
                                </b-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col sm="3" v-if="showFreigabe">
                        <b-card class="mb-0">
                            <template #header>
                                <strong>Freigabe</strong>
                            </template>
                            <b-row><b-col ><b>Freigabe: </b>{{ row.item.freigabe1 }}</b-col></b-row>
                            <b-row><b-col ><b>am </b>{{ dateToString(row.item.freigabe1_am) }}</b-col></b-row>
                            <b-row><b-col ><b>von </b>{{ row.item.freigabe1_von }}</b-col></b-row>
                        </b-card>
                    </b-col>


                </b-row>
            </template>
        </b-table>
        <div class="mt-3 custom-flex-0">
            <b-pagination v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          aria-controls="my-table" align="center"></b-pagination>
        </div>
    </b-card>
</template>

<script>
    import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
    import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
    import CurrencyEurIcon from 'vue-material-design-icons/CurrencyEur.vue';
    import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
    import {Server_URL} from "../../shared/utils";
    import {arrayBufferToBase64, decryptFile} from "../../shared/crypto";


    export default {
        name: 'AuftragTable',
        components: {
            BookOpenPageVariantIcon, CheckBoldIcon, CurrencyEurIcon, CloseCircleIcon
        },
        props:{
            tableData: {
                type: Array,
                default: () => []
            },
            rowClickCallback: {
                type: Function,
                default: undefined
            },
            showFreigabe: {
                type: Boolean,
                default: true
            },
            showIcon: {
                type: Boolean,
                default: true
            },
            allGroups: {
                default: {}
            },
            isEncrypted: {
                type: Boolean,
                default: false
            },

        },
        mounted() {
            if (!this.showIcon) {
                this.fields.shift();
            }
          this.isBauhof = navigator.userAgent.startsWith("Windows - BisOffice");
        },
        data: () => {
            return {
              isBauhof: false,
              filename: "",
                fields: [
                    {key: 'offen', label: 'Typ'},
                    {key: 'beleg_ex', label:"Nr"},
                    {key: 'gi_match', label: "Aufgabe - Wo"},
                    {key: 'gi_auf_ext', label:"Aufgabenbezeichnung", formatter: 'formateMemo'},
                    {key: 'datum', label:"Vergabe", formatter: 'dateToString'},
                    {key: 'ziel_datum', label:"Termin", formatter: 'dateToString'},
                    {key: 'quittung_datum', label:"Annahme", formatter: 'dateToString'},
                    {key: 'fertig_datum', label:"Fertigstellung", formatter: 'dateToString'},
                    {key: 'rechnung_datum', label:"Abrechnung", formatter: 'dateToString'},
                    {key: 'sachbearbeiter', label:"Aufgabensteller", formatter: (value, key, item) => {
                            if (item === null) {
                                return null;
                            }
                            let res = JSON.parse(sessionStorage.getItem(item.sachbearbeiter));
                            if (res === null) {
                                return value;
                            }
                            return res.first_name + " " + res.surname;
                        }},
                  {key: 'a_nehmer', label:"Aufgabennehmer", formatter: "formateAuftragnehmer"},
                    {details: "Details"}
                ],
                currentPage: 1,
                perPage: 20,
                url: Server_URL
            }
        },
        computed: {
            items: function() {
                const items =  this.tableData;
                return Array.isArray(items) ? items : items()
            },
            rows() {
                return this.tableData.length
            }
        },
        methods: {
            rowClicked(item, index, target) {
                this.$router.push("/auftraege/auftrag/"+item.id);

                if (this.rowClickCallback !== undefined) {
                    this.rowClickCallback(item, index);
                }
            },
            dateToString(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },
            formateMemo(value) {
                if (value === null) {
                    return "";
                }
                if (value.length > 80)
                    return value.substring(0,80) + '...';
                else
                    return value;
            },
            formateMoney(value) {
                if (value === null) {
                    return "";
                }
                return ""+value+" €"
            },
            showFile(href, filename) {
              this.filename = filename;
                if (sessionStorage.getItem("aes") !== null) {
                    this.$http.get(
                        href, {responseType: 'blob'}
                    ).then(this.onFileOk, this.responseError)
                } else {
                    window.open(href, "_blank")
                }
            },
            onFileOk(response) {
                response.blob().then(blob => {
                    blob.arrayBuffer().then(binary => {
                        decryptFile(sessionStorage.getItem("aes"), new Uint8Array(binary)).then(res => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(res),
                                this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                          const b = new Blob([res], {type: blob.type});
                            const blobUrl = URL.createObjectURL(b);
                            window.open(blobUrl, '_blank');
                        }).catch(err => {
                          if (this.isBauhof) {
                            try {
                              windowsFileService.onFile(
                                  arrayBufferToBase64(binary),
                                this.filename,
                                blob.type
                              ).then(r => {
                                if (r && !r.Success) {
                                  console.log(r)
                                }
                              }).catch(e => {
                                console.log(e)
                              });
                            } catch (e) {
                              console.log(e);
                            }
                            return
                          }
                            console.log(err);
                            const blobUrl = URL.createObjectURL(blob);
                            window.open(blobUrl, '_blank');
                        })
                    })
                });
            },
            formateAuftraggeber(value, key, item) {
                if (!this.isEncrypted) {
                    return value;
                }
                if (item === null) {
                    return null;
                }
                let res = JSON.parse(sessionStorage.getItem(item.auftraggeber));
                if (res === null) {
                    if(item.auftraggeber in this.allGroups) {
                        return this.allGroups[item.auftraggeber]
                    }

                    return value;
                }
                return res.username;
            },
          formateAuftragnehmer(value, key, item) {
            if (item === null) {
              return null;
            }

            let res = JSON.parse(sessionStorage.getItem(item.a_nehmer));
            if (res === null) {
              if(item.a_nehmer in this.allGroups) {
                return this.allGroups[item.a_nehmer]
              }

              return value;
            }
            return res.first_name + " " + res.surname;
          },

            responseError(response) {
                console.log(response)
            },
        }
    }
</script>

<style scoped>

</style>
